import {gsap} from 'gsap'

// Animation functions that can be called with any elements
export const animateFadeIn = (elements: Element[], content: Element) => {
  // Animate the elements when they are in view
  if (elements.length > 0 && content) {
    // Detect if `motion reduced` is enabled
    const isMotionReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (!isMotionReduced) {
      gsap.set(elements, {opacity: 0, y: 30})
      const observer = new IntersectionObserver(
        entries => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              const tl = gsap.timeline({delay: 0.1})

              tl.to(
                elements,
                {
                  y: 0,
                  duration: 1,
                  ease: `expo.out`,
                  stagger: 0.2,
                },
                0,
              ).to(
                elements,
                {
                  opacity: 1,
                  duration: 0.2,
                  stagger: 0.2,
                },
                0,
              )
              observer.unobserve(entry.target) // Stop observing after animation
            }
          }
        },
        {threshold: 0.5},
      )
      observer.observe(content)

      return () => {
        observer.disconnect()
      }
    }
  }
}
